import List from "@/components/list";
import Bus from "./Bus.js";

const Table = args => {

  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const toUpdate = listeners["handle-audit"] || function() {};

  function selectable(row, index) {
    if (row.auditStatus == 0) {
      return true
    }
    return false
  }
  
  function handleView({ row }) {
    if (row.auditStatus === 0) {
      Bus.$emit("update", row);
    } else {
      Bus.$emit("details", row);
    }
  }

  const toDetails = (row) => {
    Bus.$emit("details", row);
  }

  const Deal = ({ props: { vo } }) => {
    const { row } = vo
    const dealConf = []

    if (row.auditStatus === 0) {
      dealConf.push(["icon-audit", "审核", () => toUpdate(row), "user:audit:update"])
    }

    dealConf.push(["icon-steps", "查看审核详情", () => toDetails(row), "user:audit:list"])

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      selectable: selectable
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "90",
      showOverflowTooltip: true
    },
    {
      label: "原工作单位",
      prop: "oldDeptName",
      minWidth: "200"
    },
    {
      label: "原单位及职务",
      prop: "oldPosition",
      minWidth: "100"
    },
    {
      label: "调至学院",
      prop: "transFerDeptName",
      minWidth: "80"
    },
    {
      label: "调至单位",
      prop: "newDeptName",
      minWidth: "150"
    },
    {
      label: "调出操作人",
      prop: "operatorName",
      minWidth: "100"
    },
    {
      label: "操作人手机号",
      prop: "operatorMobile",
      minWidth: "100"
    },
    {
      label: "调出时间",
      prop: "moveDate",
      minWidth: "150"
    },
    {
      label: "审核状态",
      prop: "auditStatusName",
      minWidth: "100"
    },
    {
      label: "操作",
      minWidth: "60",
      fixed: "right",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List 
        {...args} 
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig} />
    </div>
  );
};
export default Table;
